import { __awaiter } from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
import { isLocalHost } from 'utils/env';
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
import { HaloEffectVerticalModule } from './HaloEffectVerticalModule';
import { verticalType } from 'pathfinder/modules/HaloEffectVerticalModule/consts';
import { isDarkTheme } from './helpers/isDarkTheme';
import waitForElement from 'pathfinder/modules/shared/helpers/waitForElement';
import { getCurrentContext } from 'pathfinder/modules/shared/utils/getCurrentContext';
import { Product } from '@fandom/context';
export const getHaloEffectVerticalModuleMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e;
    const wikiVertical = isLocalHost()
        ? verticalType.games
        : (_b = (_a = window.SilverSurferSDK.getContext()) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.productCategory;
    const moduleProps = buildModuleProps(moduleConfig, {
        wikiVertical,
        impressionName: moduleConfig.impressionName,
        isDarkTheme: isDarkTheme(),
        isForced: (_d = (_c = moduleConfig === null || moduleConfig === void 0 ? void 0 : moduleConfig.internalState) === null || _c === void 0 ? void 0 : _c.forced) !== null && _d !== void 0 ? _d : false,
    });
    const { log } = moduleProps;
    try {
        return renderDesktop(moduleProps);
    }
    catch (error) {
        (_e = log === null || log === void 0 ? void 0 : log.debug) === null || _e === void 0 ? void 0 : _e.call(log, 'HaloEffectVerticalModule error', error);
    }
});
const waitForGlobalNavOnF2 = () => __awaiter(void 0, void 0, void 0, function* () {
    // element with class global-navigation needs to be direct child of body element otherwise global navigation placeholder can be queried
    yield waitForElement(() => document.querySelector('body > .global-navigation'));
});
const renderDesktop = (moduleProps) => __awaiter(void 0, void 0, void 0, function* () {
    var _f;
    const { product } = getCurrentContext();
    const { log } = moduleProps;
    if (product === Product.F2) {
        try {
            yield waitForGlobalNavOnF2();
        }
        catch (error) {
            (_f = log.debug) === null || _f === void 0 ? void 0 : _f.call(log, 'Failed to wait for global navigation on F2', error);
            return null;
        }
        moduleProps.isDarkTheme = isDarkTheme();
    }
    const globalNavigation = document.querySelector('.global-navigation__top');
    if (globalNavigation) {
        const div = document.createElement('div');
        const render = () => {
            ReactDOM.render(React.createElement(HaloEffectVerticalModule, moduleProps), div);
        };
        globalNavigation.append(div);
        return {
            render,
        };
    }
});
